/* Keep the shop open when a customer follows an external website link. */
(() => {
  const localHosts = new Set([
    location.hostname,
    'welchtheflorist.co.uk',
    'www.welchtheflorist.co.uk',
    's6vwg0-bw.myshopify.com',
  ]);
  const serviceHosts = new Set(['accounts.shopify.com', 'checkout.shopify.com', 'shop.app']);

  function prepare(link) {
    if (!(link instanceof Element) || !link.matches('a[href]')) return;
    if (link.hasAttribute('download') || link.hasAttribute('data-no-external-tab')) return;
    let destination;
    try {
      destination = new URL(link.getAttribute('href'), location.href);
    } catch {
      return;
    }
    if (!['http:', 'https:'].includes(destination.protocol)) return;
    if (localHosts.has(destination.hostname) || serviceHosts.has(destination.hostname)) return;
    link.target = '_blank';
    const relationship = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    relationship.add('noopener');
    relationship.add('noreferrer');
    link.rel = [...relationship].join(' ');
  }

  function scan(root) {
    if (root instanceof Element && root.matches('a[href]')) prepare(root);
    root.querySelectorAll?.('a[href]').forEach(prepare);
  }

  scan(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') prepare(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();
